import { Card } from "antd";
import styled from "styled-components";

export const CardWrapper = styled(Card)`
  .ant-card-body {
    padding: 10px 20px;
  }
  .ant-tabs-nav-wrap {
    width: 99% !important;
    .ant-tabs-nav-list {
      width: 99% !important;
    }
  }
  .ant-tabs-tab {
    flex: 1; /* Make each tab take an equal width */
  }

  .ant-tabs-tab {
    display: flex;
    justify-content: center; /* Center the tab text */
    align-items: center; /* Center the tab text vertically */
  }
`;